import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="mx-auto max-w-md px-5 py-28 text-center">
      <p className="eyebrow mb-3">Nothing filed here</p>
      <h1 className="text-4xl">This page does not exist</h1>
      <p className="mt-3 text-[color:var(--color-ink-soft)]">
        The link may be old, or the address may have a typo in it.
      </p>
      <Link className="btn btn-secondary mt-7" to="/">
        Back to the start
      </Link>
    </div>
  );
}
